<template>
    <div>
        <b-overlay :show="loading">
            <div class="row">
                <div class="col-12 col-sm-9 mx-auto py-4">

                    <div class="d-flex align-content-center justify-content-between mb-1">

                        <h5 class="m-0 p-0 align-self-start">
                            {{ __('configuration.Bankrolls') }}
                        </h5>

                        <!-- Create Bankroll -->
                        <create @created="load" :locale="locale" :currency="currency"></create>

                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-5">
                            <b-list-group>
                                <!-- Item -->
                                <b-list-group-item v-for="bankroll in bankrolls" :key="bankroll.id" @click="selectBankroll(bankroll)"  :active="bankroll.id === selected" button>
                                    <span v-if="bankroll.fk_betfair_bankroll">
                                        <img src="/img/betfair.ico" class="favicon-betfair-normal mr-2" v-b-tooltip.hover :title="__('bets.Connected to Betfair')">
                                    </span>
                                    <span v-else>
                                        <i class="fas fa-wallet mr-2"></i>
                                    </span>
                                    {{ bankroll.name }}
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                        <div class="col-12 col-sm-7">
                            <edit :locale="locale" :currency="currency" @updated="load"></edit>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import Create from "./Create";
import Edit from "./Edit";

export default {
    props: ['locale', 'currency'],
    components: {
        Create,
        Edit
    },
    data() {
        return {
            selected: null,
            loading: false,
            bankrolls: [],
        }
    },
    created() {
        this.load()
    },
    methods: {

        load() {
            this.loading = true
            axios.get('/configurations/bankrolls')
                .then((result) => {
                    this.bankrolls = result
                })
                .finally(() => this.loading = false)
        },

        selectBankroll(bankroll) {
            this.selected = bankroll.id;
            this.$root.$emit('editBankroll', bankroll)
        }

    }
}
</script>

<style scoped>

</style>
